export enum PurposeOfUse {
    Importer = 'Importer',
    Exporter = 'Exporter',
    Both = 'Both'
}